import React, { useEffect, useMemo, useState } from "react";
import Layout1 from "../../DataLayouts/Layout1";
import FormatAlignJustifyIcon from '@mui/icons-material/FormatAlignJustify';
import {
  deleteOrganizationRolePermissions,
  fetchOrganizationRolePermissions,
} from '../../../Apis/ApplicationManagementApis';
import toast from "react-hot-toast";
import ViewModuleIcon from '@mui/icons-material/ViewModule';
import DescriptionIcon from '@mui/icons-material/Description';
import { useNavigate } from "react-router-dom";
import { Button } from "@mui/material";
import useAuthStore from "../../../Zustand/Store/useAuthStore";
import usePermissionDataStore from "../../../Zustand/Store/usePermissionDataStore";
import {
  USER_ROLE_PERMISSION_ADD_ACTIONS,
  USER_ROLE_PERMISSION_DELETE_ACTIONS,
  USER_ROLE_PERMISSION_EDIT_ACTIONS,
  USER_ROLE_PERMISSION_LIST,
  hasPermissionAction,
} from "../../../Utils/organizationPermissions";

function RolePermissionList() {
  const [assignment, setAssignment] = useState([]);
  const [loading, setLoading] = useState(true);
  const { userData } = useAuthStore();
  const { Permission } = usePermissionDataStore();
  const org = userData?.organization;

  const navigate = useNavigate();

  const canViewRolePermissions = useMemo(
    () => hasPermissionAction(Permission, USER_ROLE_PERMISSION_LIST),
    [Permission]
  );

  useEffect(() => {
    if (!org?.organization_id) {
      setLoading(false);
      return;
    }

    const fetchData = async () => {
      setLoading(true);
      try {
        const res = await fetchOrganizationRolePermissions(org.organization_id);
        const a = Array.isArray(res?.permissions)
          ? res.permissions
          : Array.isArray(res?.permissions?.data)
          ? res.permissions.data
          : [];

        const grouped = a.reduce((acc, curr) => {
          const roleId =
            curr.organization_user_role?.organization_user_role_id ??
            curr.organization_user_role_id;
          if (!roleId || acc[roleId]) {
            return acc;
          }
          acc[roleId] = {
            id: roleId,
            name:
              curr.organization_user_role?.user_role_name ??
              curr.organization_user_role?.role_name ??
              curr.application_user_role?.user_role_name,
          };
          return acc;
        }, {});

        const b = Object.values(grouped).map((item) => ({
          ...item,
          view: canViewRolePermissions ? (
            <Button
              variant="contained"
              size="small"
              color="primary"
              onClick={() => navigate(`/application/user-role-permission/view/${item.id}`)}
            >
              View Permissions
            </Button>
          ) : (
            "-"
          ),
        }));
        setAssignment(b);
      } catch (error) {
        console.log(error);
        toast.error("Failed to fetch role permissions");
      }
      setLoading(false);
    };

    fetchData();
  }, [canViewRolePermissions, navigate, org?.organization_id]);

  const deleteassignment = async (id) => {
    if (!org?.organization_id) {
      toast.error("Organization not found.");
      return;
    }

    try {
      await deleteOrganizationRolePermissions(org.organization_id, id);
      toast.success("Role permissions deleted successfully");
      setAssignment((prev) => prev.filter((item) => item.id !== id));
    } catch (error) {
      console.error("Delete failed:", error);
      toast.error(error.response?.data?.error || "Failed to delete User Role Permission");
    }
  };

  return (
    <Layout1
      loading={loading}
      rowsPerPage={10}
      add_action={USER_ROLE_PERMISSION_ADD_ACTIONS}
      edit_action={USER_ROLE_PERMISSION_EDIT_ACTIONS}
      delete_action={USER_ROLE_PERMISSION_DELETE_ACTIONS}
      heading={"User Role Permissions"}
      btnName={"ADD ROLE PERMISSION"}
      Data={assignment}
      tableHeaders={[
        { name: "Role", value_key: "name", textStyle: "capitalize" },
        { name: "View", value_key: "view" },
      ]}
      Icons={[
        <FormatAlignJustifyIcon sx={{ fontSize: 60, color: "grey.500", mb: 2 }} />,
        <ViewModuleIcon color="primary" />,
        <DescriptionIcon sx={{ color: "text.secondary" }} />
      ]}
      messages={[
        " Role Permission",
        " Role Permission",
        "Add  Role Permission",
        "Role Permission"
      ]}
      Route={"/application/user-role-permission"}
      setData={setAssignment}
      DeleteFunc={deleteassignment}
    />
  );
}

export default RolePermissionList;
